import LocalAuth from '@shamrock-core/common/authentication/local-authentication';

export const getAuthToken = async (getAccessToken?: () => Promise<string>) => {
  // Auth0 owns session bootstrap; LocalAuth remains only as a legacy request-token fallback.
  const localToken = LocalAuth.getTokenValue();
  return localToken ?? (getAccessToken ? getAccessToken() : undefined);
};
